import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { useDialog } from '@mews/framework';
import { IconButton, IconName } from '@optimus-web/core';
import { DeleteServicePromotionDialog } from './DeleteServicePromotionDialog';

interface ServicePromotionTableActionsProps {
    promotedService: PromotedServiceAssignment;
    openEditDialog: (data: PromotedServiceAssignment) => void;
}

export const ServicePromotionTableActions = ({
    promotedService,
    openEditDialog,
}: ServicePromotionTableActionsProps) => {
    const [deleteDialogProps, openDeleteDialog] = useDialog();
    return (
        <>
            <IconButton
                icon={IconName.Edit}
                onClick={() => openEditDialog(promotedService)}
                size="small"
                variant="ghost"
                type="submit"
            />
            <IconButton
                icon={IconName.Delete}
                onClick={() => openDeleteDialog()}
                size="small"
                variant="ghost"
                type="submit"
            />
            <DeleteServicePromotionDialog promotedService={promotedService} {...deleteDialogProps} />
        </>
    );
};
